export const trackEvent = (props) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(props);
};

export function gtm() {
  window.dataLayer = window.dataLayer || [];
  // eslint-disable-next-line prefer-rest-params
  window.dataLayer.push(arguments);
}

export const trackEcommerce = (event, ecommerce) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.ecommerce = {};
  window.dataLayer.push({
    event,
    ecommerce,
  });
};

export const trackFilter = (filter, value) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: `cc.filter.${filter}`,
    action: 'changed',
    filter,
    value,
  });
};

export default trackEvent;
